module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/favicon_ohiolink_09dc79b.png";